var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"study-rank"},[_c('chooseState',{attrs:{"chooses":_vm.chooses}}),_c('studyTable',{attrs:{"tableData":_vm.tableDataTemp,"pages":_vm.pages,"columns":_vm.columns}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }